function Heading2 (props) {
    return (
        <div className="Subtitle w-4/5 mx-auto py-12 flex justify-center">

           <div className="h-10 w-1 bg-gold"></div> <h2 className="my-auto mx-4 text-xl font-bold">{props.heading2}</h2>  <div className="h-10 w-1 bg-gold"></div>
        </div>
    );
}

export default Heading2